import { useEffect, useState } from 'react'
import { useStaticData } from '@mc/static-data-react'
import { TRACK_CONTENT_TYPES } from '@mc/track-event'
import { paths } from '@mc/paths'

import { Course, VideoGem } from 'types/data'

import CTA from 'components/CTA'
import VideoModal from 'components/VideoModal'

export const ShareGem = () => {
  const { course, shareVideoGem } = useStaticData() as unknown as StaticData
  const [isModalOpen, setIsModalOpen] = useState(false)
  useEffect(() => {
    setIsModalOpen(true)
  }, [])

  if (!shareVideoGem) return <></>

  return (
    <VideoModal
      show={isModalOpen}
      onCloseModal={() => setIsModalOpen(false)}
      videoId={shareVideoGem.brightcoveVideoId}
      mediaUuid={shareVideoGem.mediaUuid}
      author={course.instructorName ?? undefined}
      tagline={course.headline ?? undefined}
      contentId={`${course.id}_${
        shareVideoGem.brightcoveVideoId ?? shareVideoGem.mediaUuid
      }`}
      contentTitle={shareVideoGem.title}
      contentType={TRACK_CONTENT_TYPES.COURSE_TRAILER}
      courseId={course.id}
      instructorAvatar={course.primary2x3 ?? undefined}
      buttonGroup={<CTA href={paths.checkout} />}
    />
  )
}

interface StaticData {
  shareVideoGem: VideoGem
  course: Course
}
